const AbstractCloverRequestRecord = require('./AbstractCloverRequestRecord');

class CloverTransactionGetPaymentByPaymentIdRequestRecord extends AbstractCloverRequestRecord {
    /**
     * Check if a payment exists and if so return it using the paymentId which is returned as the payments.id property
     * after a successful payment transaction.
     *
     * @param {string} paymentId
     */
    constructor(paymentId) {
        if (!paymentId || paymentId.trim() === '') {
            throw new Error('paymentId is required');
        }
        // @link https://docs.clover.com/reference/get_payment
        const url = '/connect/v1/payments/' + paymentId;
        super(
            'GET',
            url
        );
    }
}

module.exports = CloverTransactionGetPaymentByPaymentIdRequestRecord;
